// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gKnX","col":"styles_col__UpoHk"};